var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-base-input-table',_vm._g(_vm._b({attrs:{"servers":_vm.servers,"data":{
        'enable-text-add': _vm.$_('w_QuickList_CreateItem', [_vm.$_(_vm.quick.title)]),
        'enable-text-edit': _vm.$_('w_QuickList_EditItem', [_vm.$_(_vm.quick.title)]),
    },"interfaces":_vm.infs,"ui-tags":_vm.tags},on:{"on-add":_vm.doAdd,"on-edit":_vm.doEdit,"on-delete":_vm.doDelete,"on-updated":_vm.doUpdated}},'iv-base-input-table',{ ..._vm.$attrs, ..._vm.$props, value: _vm.innateValue },false),{ ..._vm.$listeners }))
}
var staticRenderFns = []

export { render, staticRenderFns }